module.exports = function getResource(label, vars = []) {
    const resources = {
        editProfile: 'Edit Profile',
        profileCategories: [
            'Photos & Bio',
            'Skin',
            'Hair',
            'Eyes',
            'Color IQ',
            'Birthday',
            'Privacy'
        ],
        profileCategoriesUpdated: {
            photosbio: 'Photos & Bio',
            beautypreferences: 'Beauty Preferences',
            beautypreferencesprivacysettings: 'Beauty Preferences Privacy Settings'
        }
    };
    return resources[label];
};
